<dx-box #submittedInvoicesBox width="100%" height="100%" direction="col">
    <dxi-item baseSize="auto">
        <h2 class="page-header">
            Review My Invoices
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
            <i
                class="far fa-window-restore launch-page-link dx-theme-accent-as-text-color"
                title="Open page in new window"
                (click)="openPageInWindow()"
            ></i>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="submitted-invoices-container cc-white-background">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <div class="filter-item-content">
                                Showing Invoices within&nbsp;
                                <dx-number-box
                                    [showSpinButtons]="true"
                                    [width]="80"
                                    [min]="10"
                                    [step]="10"
                                    [(value)]="noOfDays"
                                    (onValueChanged)="doRefresh()"
                                ></dx-number-box>
                                &nbsp;Days
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Submit Invoice"
                                hint="Submit Invoice"
                                [icon]="iconAdd"
                                (onClick)="onSubmitInvoice()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        #gridFeatures
                        [stateConfig]="{ storageKey: 'MY_SUBMITTED_INVOICES_GRID' }"
                        [dataSource]="submittedInvoices"
                    >
                        <dx-data-grid
                            appHasInternalUserColumns
                            width="100%"
                            height="100%"
                            class="cc-vertical-center-cell-data-grid"
                            [dataSource]="submittedInvoices"
                        >
                            <dxi-column
                                name="RestrictedColumn|WORKFLOW_DETAILS"
                                dataField="workflowId"
                                dataType="string"
                                cellTemplate="workflowCellTemplate"
                            ></dxi-column>
                            <dxi-column dataField="startTime" dataType="date" [format]="dateFormat"></dxi-column>
                            <dxi-column dataField="paymentDate" dataType="date" [format]="dateFormat"></dxi-column>
                            <dxi-column dataField="checkNumber" dataType="string"></dxi-column>
                            <dxi-column
                                dataField="community"
                                dataType="string"
                                cellTemplate="communityCellTemplate"
                            ></dxi-column>
                            <dxi-column dataField="status" dataType="string"></dxi-column>
                            <dxi-column
                                dataField="vendor"
                                dataType="string"
                                cellTemplate="vendorCellTemplate"
                            ></dxi-column>
                            <dxi-column dataField="invoiceNumber" dataType="string"></dxi-column>
                            <dxi-column
                                dataField="amount"
                                dataType="number"
                                [format]="currencyFormat"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceFile.fileName"
                                dataType="string"
                                caption=""
                                alignment="center"
                                cellTemplate="invoiceFileCellTemplate"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                name="InternalLogs"
                                dataType="string"
                                caption="Logs"
                                alignment="center"
                                cellTemplate="logsCellTemplate"
                                [showInColumnChooser]="false"
                                [allowFiltering]="false"
                                [allowHeaderFiltering]="false"
                                [allowGrouping]="false"
                                [allowSorting]="false"
                            ></dxi-column>
                            <dxi-column
                                name="InternalNotes"
                                dataField="hasNotes"
                                dataType="boolean"
                                caption="Notes"
                                alignment="center"
                                cellTemplate="notesCellTemplate"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="location"
                                caption="Location"
                                dataType="string"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="office"
                                caption="Office"
                                dataType="string"
                                [visible]="false"
                            ></dxi-column>

                            <div *dxTemplate="let row of 'workflowCellTemplate'">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    actionCode="WORKFLOW_DETAILS"
                                    [displayText]="row.value"
                                    [communityId]="row.data.communityId"
                                    (onLinkClick)="onWorkflowClick(row.data)"
                                ></app-hyperlink-creator>
                            </div>
                            <div *dxTemplate="let row of 'communityCellTemplate'">
                                <app-property-community-link
                                    [communityId]="row.data.communityId"
                                    [displayText]="row.value"
                                ></app-property-community-link>
                            </div>

                            <div *dxTemplate="let row of 'vendorCellTemplate'">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    actionCode="VENDOR_MANAGEMENT"
                                    [displayText]="row.value"
                                    (onLinkClick)="onVendorNameClick(row.data)"
                                ></app-hyperlink-creator>
                            </div>

                            <div *dxTemplate="let row of 'invoiceFileCellTemplate'">
                                <i
                                    *ngIf="row.data.invoiceFile && row.data.invoiceFile.downloadUrl"
                                    class="cc-1-5x cc-icon-pdf cc-hyperlink"
                                    [ngClass]="iconPDF"
                                    (click)="onDownloadFile(row.data.invoiceFile)"
                                ></i>
                            </div>
                            <div *dxTemplate="let row of 'logsCellTemplate'">
                                <i
                                    class="cc-1-5x cc-hyperlink dx-theme-accent-as-text-color"
                                    [ngClass]="iconLogs"
                                    (click)="onLogsClick(row.data)"
                                ></i>
                            </div>
                            <div *dxTemplate="let row of 'notesCellTemplate'">
                                <i
                                    *ngIf="row.value"
                                    class="cc-1-5x cc-icon-check cc-hyperlink"
                                    [ngClass]="iconNotes"
                                    (click)="onNotesClick(row.data)"
                                ></i>
                                <i
                                    *ngIf="!row.value"
                                    class="cc-1-5x cc-hyperlink dx-theme-accent-as-text-color"
                                    [ngClass]="iconEmptyNotes"
                                    (click)="onNotesClick(row.data)"
                                ></i>
                            </div>

                            <dxo-summary>
                                <dxi-group-item
                                    column="workflowId"
                                    summaryType="count"
                                    displayFormat="Count = {0}"
                                ></dxi-group-item>
                            </dxo-summary>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<app-workflow-notes-editor
    *ngIf="showNotes && selectedRecord"
    [workflowId]="selectedRecord.workflowId"
    [communityId]="selectedRecord.communityId"
    [hasNotes]="selectedRecord.hasNotes"
    (closeNotesPopUp)="onNotesClose($event)"
></app-workflow-notes-editor>

<app-workflow-history
    *ngIf="showLogs && selectedRecord"
    [workflowId]="selectedRecord.workflowId"
    [communityId]="selectedRecord.communityId"
    (onClose)="onLogsClose($event)"
></app-workflow-history>

<dx-popup
    *ngIf="showSubmitInvoice"
    title="AP Payment Request"
    width="85%"
    height="85%"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="showSubmitInvoice"
    (onShown)="$event.component.repaint()"
    (onHidden)="showSubmitInvoice = false"
>
    <div *dxTemplate="let data of 'content'">
        <app-workflow-payment-request
            [isPopup]="true"
            (onClose)="onSubmitInvoiceClose($event)"
        ></app-workflow-payment-request>
    </div>
</dx-popup>

<app-detail-popups [isCorporateCirabook]="isCorporateCirabook"></app-detail-popups>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#submittedInvoicesBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
